// Internet Explorer 11 requires polyfills and partially supported by this project.
// import 'react-app-polyfill/ie11';
// import 'react-app-polyfill/stable';
import App from '@ameroservices-platform/loppe-flexposui/app//App';
import './i18n';
import './styles/app-base.css';
import './styles/app-components.css';
import './styles/app-utilities.css';
import '@fontsource/roboto';
import ReactDOM from 'react-dom';

ReactDOM.render(<App />, document.getElementById('root'));
